import { render, staticRenderFns } from "./CircleProgressBar.vue?vue&type=template&id=3058506c&lang=pug"
import script from "./CircleProgressBar.vue?vue&type=script&lang=js"
export * from "./CircleProgressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports